import styled from '@emotion/styled'

export const Caption = styled('div')(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  fontSize: theme.fontSize.small,
  color: theme.colors.text.muted,
}))
